import i18next from 'i18next';

export const placeholders = (): { [key: string]: any } => {
  return {
    learner: {
      last_name: i18next.t('register.form.input.last_name'),
      first_name: i18next.t('register.form.input.first_name'),
      password: i18next.t('register.form.input.password_placeholder'),
      password_confirmation: i18next.t(
        'register.form.input.password_confirmation_placeholder',
      ),
      inputted_by_parents: i18next.t(
        'registration.sign_up.new.register_learner_for_study_web.inputted_by_parents',
      ),
      username: i18next.t('register.form.input.username_placeholder'),
      enable_username_auto_generation: i18next.t(
        'register.form.input.enable_username_auto_generation',
      ),
      aya_profile: {
        last_name_kana: i18next.t('register.form.input.last_name_kana'),
        first_name_kana: i18next.t('register.form.input.first_name_kana'),
        birth_year: i18next.t('register.form.input.year'),
        birth_month: i18next.t('register.form.input.month'),
        birth_day: i18next.t('register.form.input.day'),
        grade_id: i18next.t('register.form.input.grade_placeholder'),
        receive_study_report: i18next.t(
          'registration.sign_up.new.register_learner_for_study_web.receive_study_report',
        ),
      },
    },
    account: {
      last_name: i18next.t('register.form.input.last_name'),
      first_name: i18next.t('register.form.input.first_name'),
      last_name_kana: i18next.t('register.form.input.last_name_kana'),
      first_name_kana: i18next.t('register.form.input.first_name_kana'),
      birth_year: i18next.t('register.form.input.year'),
      birth_month: i18next.t('register.form.input.month'),
      birth_day: i18next.t('register.form.input.day'),
      phone_number: i18next.t('register.form.input.phone_number_placeholder'),
      email: i18next.t('register.form.input.email'),
      password: i18next.t('register.form.input.password_placeholder'),
      password_confirmation: i18next.t(
        'register.form.input.password_confirmation_placeholder',
      ),
      receive_latest_info: i18next.t('register.form.input.receive_mail'),
    },
    learner_account: {
      last_name: i18next.t('register.form.input.last_name'),
      first_name: i18next.t('register.form.input.first_name'),
      last_name_kana: i18next.t('register.form.input.last_name_kana'),
      first_name_kana: i18next.t('register.form.input.first_name_kana'),
      birth_year: i18next.t('register.form.input.year'),
      birth_month: i18next.t('register.form.input.month'),
      birth_day: i18next.t('register.form.input.day'),
      phone_number: i18next.t('register.form.input.phone_number_placeholder'),
      email: i18next.t('register.form.input.email'),
      username: i18next.t('register.form.input.username_placeholder'),
      enable_username_auto_generation: i18next.t(
        'register.form.input.enable_username_auto_generation',
      ),
      grade_id: i18next.t('register.form.input.grade_placeholder'),
      password: i18next.t('register.form.input.password_placeholder'),
      password_confirmation: i18next.t(
        'register.form.input.password_confirmation_placeholder',
      ),
      inputted_by_parents: i18next.t(
        'registration.sign_up.new.register_learner_for_study_web.inputted_by_parents',
      ),
      receive_latest_info: i18next.t('register.form.input.receive_mail'),
      receive_webdm_remind_permission: i18next.t(
        'register.form.input.receive_webdm_remind_permission',
      ),
    },
    receive_latest_info_notes: i18next.t(
      'register.form.input.receive_mail_notes',
      { returnObjects: true },
    ),
    receive_webdm_remind_permission_notes: i18next.t(
      'register.form.input.receive_webdm_remind_permission_notes',
      { returnObjects: true },
    ),
    verification: {
      code: i18next.t('register.form.input.verification_code_placeholder'),
    },
    school_learner: {
      last_name: i18next.t('register.form.input.last_name'),
      first_name: i18next.t('register.form.input.first_name'),
      last_name_kana: i18next.t('register.form.input.last_name_kana'),
      first_name_kana: i18next.t('register.form.input.first_name_kana'),
      birth_year: i18next.t('register.form.input.year'),
      birth_month: i18next.t('register.form.input.month'),
      birth_day: i18next.t('register.form.input.day'),
      password: i18next.t('register.form.input.password_placeholder'),
      password_confirmation: i18next.t(
        'register.form.input.password_confirmation_placeholder',
      ),
      grade: i18next.t('register.form.input.grade_placeholder'),
      class_name: i18next.t('register.form.input.class_name'),
      attendance_number: i18next.t('register.form.input.attendance_number'),
      consent_to_schools: i18next.t(
        'registration.sign_up.new.register_school_info.consent_to_schools',
      ),
      inputted_by_parents: i18next.t(
        'registration.sign_up.new.register_school_info.inputted_by_parents',
      ),
      colleges: [
        {
          college_department: i18next.t(
            'register.form.input.preferred_college_department_placeholder',
          ),
        },
        {
          college_department: i18next.t(
            'register.form.input.preferred_college_department_placeholder',
          ),
        },
        {
          college_department: i18next.t(
            'register.form.input.preferred_college_department_placeholder',
          ),
        },
      ],
      use_organization_membership_code_as_username: i18next.t(
        'registration.sign_up.new.register_school_learner.use_organization_membership_code_as_username',
      ),
    },
    applyDiscountPriceCampaign: '適用する',
    proto: {
      japanese: '国語',
      math: '算数',
      english: '英語',
      social_studies: '社会',
      science: '理科',
    },
  };
};

export const autoCompletes: { [key: string]: any } = {
  learner: {
    last_name: 'family-name',
    first_name: 'given-name',
    password: 'new-password',
    password_confirmation: 'new-password',
    aya_profile: {
      last_name_kana: 'family-name',
      first_name_kana: 'given-name',
    },
  },
  account: {
    last_name: 'family-name',
    first_name: 'given-name',
    last_name_kana: 'family-name',
    first_name_kana: 'given-name',
    phone_number: 'tel',
    email: 'email',
    password: 'new-password',
    password_confirmation: 'new-password',
  },
  learner_account: {
    last_name: 'family-name',
    first_name: 'given-name',
    last_name_kana: 'family-name',
    first_name_kana: 'given-name',
    phone_number: 'tel',
    email: 'email',
    password: 'new-password',
    password_confirmation: 'new-password',
  },
  school_learner: {
    // name fields should be auto-filled by organization membership information
    password: 'new-password',
    password_confirmation: 'new-password',
  },
};

export const ids: { [key: string]: any } = {
  learner: {
    last_name: 'learner_last_name',
    first_name: 'learner_first_name',
    gender: 'learner_gender',
    password: 'learner_password',
    password_confirmation: 'learner_password_confirmation',
    inputted_by_parents: 'learner_inputted_by_parents',
    username: 'learner_username',
    enable_username_auto_generation: 'learner_enable_username_auto_generation',
    aya_profile: {
      last_name_kana: 'learner_aya_profile_last_name_kana',
      first_name_kana: 'learner_aya_profile_first_name_kana',
      birth_year: 'learner_aya_profile_birth_year',
      birth_month: 'learner_aya_profile_birth_month',
      birth_day: 'learner_aya_profile_birth_day',
      grade_id: 'learner_aya_profile_grade_id',
      receive_study_report: 'learner_aya_profile_receive_study_report',
    },
  },
  account: {
    last_name: 'account_last_name',
    first_name: 'account_first_name',
    last_name_kana: 'account_last_name_kana',
    first_name_kana: 'account_first_name_kana',
    birth_year: 'account_birth_year',
    birth_month: 'account_birth_month',
    birth_day: 'account_birth_day',
    phone_number: 'account_phone_number',
    email: 'account_email',
    password: 'account_password',
    password_confirmation: 'account_password_confirmation',
    receive_latest_info: 'account_receive_latest_info',
  },
  learner_account: {
    last_name: 'learner_account_last_name',
    first_name: 'learner_account_first_name',
    last_name_kana: 'learner_account_last_name_kana',
    first_name_kana: 'learner_account_first_name_kana',
    birth_year: 'learner_account_birth_year',
    birth_month: 'learner_account_birth_month',
    birth_day: 'learner_account_birth_day',
    gender: 'learner_account_gender',
    gender_expression: 'learner_account_gender_expression',
    phone_number: 'learner_account_phone_number',
    email: 'learner_account_email',
    username: 'learner_account_username',
    enable_username_auto_generation:
      'learner_account_enable_username_auto_generation',
    password: 'learner_account_password',
    password_confirmation: 'learner_account_password_confirmation',
    inputted_by_parents: 'learner_account_inputted_by_parents',
    receive_latest_info: 'learner_account_receive_latest_info',
    receive_study_report: 'learner_aya_profile_receive_study_report',
    receive_webdm_remind_permission:
      'learner_account_receive_webdm_remind_permission',
  },
  account_address: {
    zip_code: 'account_address_zip_code',
    prefecture: 'account_address_prefecture',
    city: 'account_address_city',
    district: 'account_address_district',
    street: 'account_address_street',
    blank_street: 'account_address_blank_street',
  },
  verification: {
    code: 'verification_code',
  },
  school_learner: {
    last_name: 'school_learner_last_name',
    first_name: 'school_learner_first_name',
    last_name_kana: 'school_learner_last_name_kana',
    first_name_kana: 'school_learner_first_name_kana',
    birth_year: 'school_learner_birth_year',
    birth_month: 'school_learner_birth_month',
    birth_day: 'school_learner_birth_day',
    gender: 'school_learner_gender',
    gender_expression: 'school_learner_gender_expression',
    username: 'school_learner_username',
    password: 'school_learner_password',
    password_confirmation: 'school_learner_password_confirmation',
    grade: 'school_learner_grade',
    class_name: 'school_learner_class_name',
    attendance_number: 'school_learner_attendance_number',
    consent_to_schools: 'school_learner_consent_to_schools',
    inputted_by_parents: 'school_learner_inputted_by_parents',
    use_organization_membership_code_as_username:
      'school_learner_use_organization_membership_code_as_username',
  },
};
